import token from 'styled-token';

/** @mixin lineHeightTypeMixin */
/**
 * Get the line height for the given font type.
 *
 * @example
 * import { lineHeightTypeMixin } from '@zillow/constellation';
 *
 * // Add support for "fontType" prop
 * const Component = styled.div`
 *     ${lineHeightTypeMixin}
 * `;
 *
 * // Adds a default font type
 * const ComponentWithDefault = styled.div`
 *     ${props => lineHeightTypeMixin({ fontType: 'h1', ...props })}
 * `;
 *
 * <Component fontType="h2">h2 line height</Component>
 * <ComponentWithDefault>h1 line height by default</ComponentWithDefault>
 * <ComponentWithDefault fontType="h3">h3 line height</ComponentWithDefault>
 *
 * @method
 * @param {object} props
 * @param {string} props.fontType - The `fontType` key for the `lineHeights` object.
 * @param {object} props.theme - The styled-components theme object with a `lineHeights` object.
 * @return {Interpolation}
 */
export var lineHeightTypeMixin = function lineHeightTypeMixin(props) {
  var fontType = props.fontType;
  if (!fontType) {
    return '';
  }
  return token({
    lineHeights: 'lineHeights',
    defaultUnit: 'defaultUnit'
  }, function (_ref) {
    var lineHeights = _ref.lineHeights,
      defaultUnit = _ref.defaultUnit;
    var lineHeight = lineHeights && lineHeights[fontType];
    if (lineHeight && defaultUnit) {
      return "line-height: " + (lineHeight + defaultUnit) + ";";
    }
    return '';
  })(props);
};